export const actions = {
  ETIQUETAS_URL_LOAD_REQUESTED: 'ETIQUETAS_URL_LOAD_REQUESTED',
  ETIQUETAS_URL_LOAD_SUCCEEDED: 'ETIQUETAS_URL_LOAD_SUCCEEDED',
  ETIQUETAS_URL_LOAD_FILED: 'ETIQUETAS_URL_LOAD_FILED',

  ETIQUETAS_URL_INSERT_REQUESTED: 'ETIQUETAS_URL_INSERT_REQUESTED',
  ETIQUETAS_URL_INSERT_SUCCEEDED: 'ETIQUETAS_URL_INSERT_SUCCEEDED',
  ETIQUETAS_URL_INSERT_FILED: 'ETIQUETAS_URL_INSERT_FILED',

  ETIQUETAS_URL_UPDATE_REQUESTED: 'ETIQUETAS_URL_UPDATE_REQUESTED',
  ETIQUETAS_URL_UPDATE_SUCCEEDED: 'ETIQUETAS_URL_UPDATE_SUCCEEDED',
  ETIQUETAS_URL_UPDATE_FILED: 'ETIQUETAS_URL_UPDATE_FILED',

  ETIQUETAS_URL_SORT_UPDATE_REQUESTED: 'ETIQUETAS_URL_SORT_UPDATE_REQUESTED',
  ETIQUETAS_URL_SORT_UPDATE_SUCCEEDED: 'ETIQUETAS_URL_SORT_UPDATE_SUCCEEDED',
  ETIQUETAS_URL_SORT_UPDATE_FILED: 'ETIQUETAS_URL_SORT_UPDATE_FILED',

  ETIQUETA_URL_DELETE_REQUESTED: 'ETIQUETA_URL_DELETE_REQUESTED',
  ETIQUETA_URL_DELETE_SUCCEEDED: 'ETIQUETA_URL_DELETE_SUCCEEDED',
  ETIQUETA_URL_DELETE_FILED: 'ETIQUETA_URL_DELETE_FILED',
}

// idiomaId es opcional: si se pasa, la API sólo devuelve las urls marcadas como
// visibles (Mostrar) en ese idioma.
export const getEtiquetasUrlAction = (dispatch, etiquetaId, idiomaId = null) => {
  dispatch({
    type: actions.ETIQUETAS_URL_LOAD_REQUESTED,
    payload: { id: etiquetaId, idiomaId },
  })
}

export const onSubmitEtiquetaUrlAction = (dispatch, etiquetaUrlForm) => {
  dispatch({
    type: actions.ETIQUETAS_URL_INSERT_REQUESTED,
    payload: etiquetaUrlForm,
  })
}

export const onSubmitEtiquetaUrlSortUpdateAction = (dispatch, etiquetaUrlSortForm) => {
  dispatch({
    type: actions.ETIQUETAS_URL_SORT_UPDATE_REQUESTED,
    payload: etiquetaUrlSortForm,
  })
}

export const onSubmitEtiquetaUrlUpdateAction = (dispatch, etiquetaUrlForm) => {
  dispatch({
    type: actions.ETIQUETAS_URL_UPDATE_REQUESTED,
    payload: etiquetaUrlForm,
  })
}

export const deleteEtiquetaUrlAction = (dispatch, id) => {
  dispatch({
    type: actions.ETIQUETA_URL_DELETE_REQUESTED,
    payload: id,
  })
}
